import React, { useState } from "react"
import types from "prop-types"
import { categoryShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import SvgSpriteIcon from "shared/SvgSpriteIcon"
import { questionTypeIcon, questionTypeLabel } from "utils/reportableFieldHelpers"
import UpdateReportableFieldsForm from "./UpdateReportableFieldsForm"
import ReportableFieldMenu from "./ReportableFieldMenu"

const ReportableField = ({
  reportableFields, field, setReportableFields, category,
}) => {
  const [isUpdateFormVisible, setIsUpdateFormVisible] = useState(false)

  const { description, name } = field

  const setFormEditField = () => setIsUpdateFormVisible(true)
  const cancelForm = () => setIsUpdateFormVisible(false)

  if (isUpdateFormVisible) {
    return (
      <UpdateReportableFieldsForm
        visible={isUpdateFormVisible}
        reportableField={field}
        cancelForm={cancelForm}
        categorySlug={category.slug}
        reportableFields={reportableFields}
        setReportableFields={setReportableFields}
      />
    )
  }

  return (
    <ItemRow
      className="dark"
      itemRowHeaderContent={(
        <>
          <span>{name}</span>
          <div className="flex items-center gap-2">
            <SvgSpriteIcon iconName={questionTypeIcon(field)} />
            <span className="text-sm text-dark">{ questionTypeLabel({ ...field }) }</span>
          </div>
        </>
      )}
      itemRowHeaderControls={(
        <ReportableFieldMenu
          reportableFieldId={field.id}
          reportableFields={reportableFields}
          setReportableFields={setReportableFields}
          field={field}
          setFormEditField={setFormEditField}
          categorySlug={category.slug}
        />
      )}
      itemRowBody={(
        <>
          {
            description && (
              <p className="text-sm text-dark">{description}</p>
            )
          }
        </>
      )}
    />
  )
}

ReportableField.propTypes = {
  category: categoryShape.isRequired,
  field: types.shape({
    id: types.number,
    name: types.string,
    description: types.string,
    questionType: types.string,
  }).isRequired,
  reportableFields: types.arrayOf(types.object).isRequired,
  setReportableFields: types.func.isRequired,
}

export default ReportableField
